export enum MDateNavigatorDirection {
  Backword,
  Now,
  Forward,
}
